module.exports = __webpack_public_path__ + "static/media/jcb.479b6af6.png";